import { render, staticRenderFns } from "./LearnSection.vue?vue&type=template&id=35715666&"
import script from "./LearnSection.vue?vue&type=script&lang=js&"
export * from "./LearnSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports